/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Badge_TitleInputs */

const vi_whats_new_badge_title = /** @type {(inputs: Whats_New_Badge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có gì mới`)
};

/**

* @param {Whats_New_Badge_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_badge_title = /** @type {((inputs?: Whats_New_Badge_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Badge_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_badge_title(inputs)
});